import React from 'react'

function CookieDeclaration() {
  return (
    <div>CookieDeclaration</div>
  )
}

export default CookieDeclaration